
import React from 'react';
import GlassCard from './common/GlassCard';
import * as Constants from '../constants';
import "./HeroSection.scss";
import type { Feature } from '../types';
import { CpuChipIcon, ChatBubbleLeftRightIcon, AdjustmentsHorizontalIcon, ChartBarSquareIcon, BookOpenIcon } from './icons/Heroicons';

const features: Feature[] = [
  { 
    icon: <CpuChipIcon className="w-12 h-12 text-teal-600 mb-4" />, 
    title: Constants.FEATURE_1_TITLE, 
    description: Constants.FEATURE_1_BENEFIT 
  },
  { 
    icon: <ChatBubbleLeftRightIcon className="w-12 h-12 text-teal-600 mb-4" />, 
    title: Constants.FEATURE_2_TITLE, 
    description: Constants.FEATURE_2_BENEFIT 
  },
  { 
    icon: <AdjustmentsHorizontalIcon className="w-12 h-12 text-teal-600 mb-4" />, 
    title: Constants.FEATURE_3_TITLE, 
    description: Constants.FEATURE_3_BENEFIT 
  },
  { 
    icon: <ChartBarSquareIcon className="w-12 h-12 text-teal-600 mb-4" />, 
    title: Constants.FEATURE_4_TITLE, 
    description: Constants.FEATURE_4_BENEFIT 
  },
  { 
    icon: <BookOpenIcon className="w-12 h-12 text-teal-600 mb-4" />, 
    title: Constants.FEATURE_5_TITLE, 
    description: Constants.FEATURE_5_BENEFIT 
  },
];

const FeaturesSection: React.FC = () => {
  return (
    <section id="features-section"    className="snap-section pt-24 md:pt-32 bg-gradient-to-br from-slate-100 via-purple-100 to-pink-100">
      <div className="container mx-auto px-6 py-16 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-600 HeroTitle">
          {Constants.FEATURES_HEADLINE}
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <GlassCard key={index} className="flex flex-col items-center text-left hover:shadow-teal-400/50 transition-shadow duration-300 transform hover:-translate-y-1 bg-white/60">
              <div className="flex justify-center w-full mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-3 text-slate-700 text-center">{feature.title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{feature.description}</p>
            </GlassCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
